import React, { useState, useEffect } from 'react';
import UDIRowPopup, { UDIPopupField, UDIAddRowButton, useUDIRowPopup } from './UDIRowPopup.js';

const ClinicalSizes = ({
    UDI,
    setUDI,
    initialData = '[]',
    hiddenFieldName = "Form.EUProductUDI.ClinicalSizes",
    fieldTitle = "Clinical Sizes",
    forceIsEditing = null
}) => {
    // --- Dictionaries ---
    const sizeTypes = [
        { key: "1", value: "CST33" }, { key: "2", value: "CST66" }, { key: "3", value: "CST67" },
        { key: "4", value: "CST999" }, { key: "5", value: "CST1" }, { key: "6", value: "CST2" },
        { key: "7", value: "CST3" }, { key: "8", value: "CST4" }, { key: "9", value: "CST5" },
        { key: "10", value: "CST6" }, { key: "11", value: "CST7" }, { key: "12", value: "CST8" },
        { key: "13", value: "CST9" }, { key: "14", value: "CST10" }, { key: "15", value: "CST11" },
        { key: "16", value: "CST12" }, { key: "17", value: "CST13" }, { key: "18", value: "CST14" },
        { key: "19", value: "CST15" }, { key: "20", value: "CST16" }, { key: "21", value: "CST17" },
        { key: "22", value: "CST18" }, { key: "23", value: "CST19" }, { key: "24", value: "CST20" },
        { key: "25", value: "CST21" }, { key: "26", value: "CST22" }, { key: "27", value: "CST23" },
        { key: "28", value: "CST24" }, { key: "29", value: "CST25" }, { key: "30", value: "CST26" },
        { key: "31", value: "CST27" }, { key: "32", value: "CST28" }, { key: "33", value: "CST29" },
        { key: "34", value: "CST30" }, { key: "35", value: "CST31" }, { key: "36", value: "CST32" },
        { key: "37", value: "CST34" }, { key: "38", value: "CST35" }, { key: "39", value: "CST36" },
        { key: "40", value: "CST37" }, { key: "41", value: "CST38" }, { key: "42", value: "CST39" },
        { key: "43", value: "CST40" }, { key: "44", value: "CST41" }, { key: "45", value: "CST42" },
        { key: "46", value: "CST43" }, { key: "47", value: "CST44" }, { key: "48", value: "CST45" },
        { key: "49", value: "CST46" }, { key: "50", value: "CST47" }, { key: "51", value: "CST48" },
        { key: "52", value: "CST49" }, { key: "53", value: "CST50" }, { key: "54", value: "CST51" },
        { key: "55", value: "CST52" }, { key: "56", value: "CST53" }, { key: "57", value: "CST54" },
        { key: "58", value: "CST55" }, { key: "59", value: "CST56" }, { key: "60", value: "CST57" },
        { key: "61", value: "CST58" }, { key: "62", value: "CST59" }, { key: "63", value: "CST60" },
        { key: "64", value: "CST61" }, { key: "65", value: "CST62" }, { key: "66", value: "CST63" },
        { key: "67", value: "CST65" }
    ];

    const precision = [
        { key: "1", value: "range" }, { key: "2", value: "text" }, { key: "3", value: "value" }
    ];

    const measureUnits = [
        { key: "MU01", value: "%" }, { key: "MU02", value: "/litre (/L)" }, { key: "MU03", value: "/millilitre (/mL)" },
        { key: "MU04", value: "/millimole (/mmol)" }, { key: "MU138", value: "Active" }, { key: "MU168", value: "Adult" },
        { key: "MU107", value: "ampere (A)" }, { key: "MU140", value: "Angled" }, { key: "MU87", value: "atomic mass unit: u" },
        { key: "MU126", value: "bar (bar)" }, { key: "MU122", value: "becquerel (Bq)" }, { key: "MU133", value: "bel (B)" },
        { key: "MU154", value: "Belt" }, { key: "MU109", value: "candela (cd)" }, { key: "MU09", value: "centilitre (cL)" },
        { key: "MU10", value: "centimetre (cm)" }, { key: "MU167", value: "Child" }, { key: "MU158", value: "Concave" },
        { key: "MU151", value: "Contour" }, { key: "MU156", value: "Convex" }, { key: "MU113", value: "coulomb (C)" },
        { key: "MU12", value: "cubic centimetre (cu cm or cm3)" }, { key: "MU14", value: "cup" }, { key: "MU175", value: "Curved" },
        { key: "MU131", value: "dalton (Da)" }, { key: "MU15", value: "day (d)" }, { key: "MU134", value: "decibel (dB)" },
        { key: "MU16", value: "decilitre (dL)" }, { key: "MU17", value: "decimetre (dm)" }, { key: "MU105", value: "degree (°)" },
        { key: "MU18", value: "degree Celsius (°C)" }, { key: "MU104", value: "dioptre (D)" }, { key: "MU127", value: "electronvolt (eV)" },
        { key: "MU164", value: "Extra large (XL)" }, { key: "MU160", value: "Extra small (XS)" }, { key: "MU117", value: "farad (F)" },
        { key: "MU21", value: "femtolitre (fL)" }, { key: "MU159", value: "Flat" }, { key: "MU23", value: "foot (ft)" },
        { key: "MU170", value: "French (F)" }, { key: "MU24", value: "gram (g)" }, { key: "MU123", value: "gray (Gy)" },
        { key: "MU27", value: "hertz (Hz)" }, { key: "MU26", value: "hour (h)" }, { key: "MU28", value: "inch (in)" },
        { key: "MU166", value: "Infant" }, { key: "MU05", value: "international unit [IU]" }, { key: "MU112", value: "joule (J)" },
        { key: "MU141", value: "J-tip" }, { key: "MU125", value: "katal (kat)" }, { key: "MU108", value: "kelvin (K)" },
        { key: "MU29", value: "kilogram (kg)" }, { key: "MU31", value: "kilometre (km)" }, { key: "MU32", value: "kilopascal (kPa)" },
        { key: "MU163", value: "Large (L)" }, { key: "MU172", value: "left" }, { key: "MU34", value: "litre (L)" },
        { key: "MU106", value: "lumen (lm)" }, { key: "MU121", value: "lux (lx)" }, { key: "MU162", value: "Medium (M)" },
        { key: "MU36", value: "metre (m)" }, { key: "MU40", value: "microgram (μg)" }, { key: "MU42", value: "microlitre (μL or μl)" },
        { key: "MU43", value: "micrometre (μm)" }, { key: "MU44", value: "micromole (μmol)" }, { key: "MU48", value: "millilitre (mL)" },
        { key: "MU50", value: "millimetre (mm)" }, { key: "MU52", value: "millimole (mmol)" }, { key: "MU55", value: "minute (min)" },
        { key: "MU165", value: "Neonate" }, { key: "MU110", value: "newton (N)" }, { key: "MU115", value: "ohm (Ω)" },
        { key: "MU111", value: "pascal (Pa)" }, { key: "MU173", value: "right" }, { key: "MU81", value: "second (s)" },
        { key: "MU161", value: "Small (S)" }, { key: "MU152", value: "Square" }, { key: "MU176", value: "Standard" },
        { key: "MU139", value: "Straight" }, { key: "MU102", value: "year" }, { key: "MU999", value: "OTHER" }
    ];

    const languages = [
        { key: "en", value: "English" }, { key: "is", value: "Icelandic" }, { key: "no", value: "Norwegian" },
        { key: "tr", value: "Turkish" }, { key: "bg", value: "Bulgarian" }, { key: "cs", value: "Czech" },
        { key: "da", value: "Danish" }, { key: "de", value: "German" }, { key: "et", value: "Estonian" },
        { key: "el", value: "Greek" }, { key: "es", value: "Spanish" }, { key: "fr", value: "French" },
        { key: "hr", value: "Croatian" }, { key: "it", value: "Italian" }, { key: "lv", value: "Latvian" },
        { key: "lt", value: "Lithuanian" }, { key: "hu", value: "Hungarian" }, { key: "mt", value: "Maltese" },
        { key: "nl", value: "Dutch" }, { key: "pl", value: "Polish" }, { key: "pt", value: "Portuguese" },
        { key: "ro", value: "Romanian" }, { key: "sk", value: "Slovak" }, { key: "sl", value: "Slovenian" },
        { key: "fi", value: "Finnish" }, { key: "sv", value: "Swedish" }, { key: "ga", value: "Irish" }
    ];

    // --- State ---
    const [items, setItems] = useState(() => {
        try {
            return (typeof initialData === 'string' ? JSON.parse(initialData) : initialData) || [];
        }
        catch(e) {
            return [];
        }
    });

    const initialFormState = {
        SizeType: { Value: '1', Text: 'CST33' },
        Precizion: { Value: '1', Text: 'range' },
        MeasureUnit: { Value: 'MU01', Text: '%' },
        Maximum: '',
        Minimum: '',
        Value: '',
        ValueText: '',
        TypeDescription: { Value: '', Language: { Value: 'en', Text: 'English' } },
        UnitDescription: { Value: '', Language: { Value: 'en', Text: 'English' } }
    };

    const [isEditing, setIsEditing] = useState(forceIsEditing != null ? forceIsEditing : false);
    const [formData, setFormData] = useState(initialFormState);
    const [editingIndex, setEditingIndex] = useState(null);

    // --- Handlers ---
    const handleDropdownChange = (e, field, dictionary) => {
        const val = e.target.value;
        const text = dictionary.find(d => d.key === val)?.value;
        setFormData(prev => ({
            ...prev,
            [field]: { Value: val, Text: text }
        }));
    };

    const handleNestedLanguageChange = (e, parentField) => {
        const val = e.target.value;
        const text = languages.find(l => l.key === val)?.value;
        setFormData(prev => ({
            ...prev,
            [parentField]: {
                ...prev[parentField],
                Language: { Value: val, Text: text }
            }
        }));
    };

    const handleNestedValueChange = (e, parentField) => {
        const val = e.target.value;
        setFormData(prev => ({
            ...prev,
            [parentField]: { ...prev[parentField], Value: val }
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        const updatedItems = [...items];
        if (editingIndex !== null) {
            updatedItems[editingIndex] = formData;
        } else {
            updatedItems.push(formData);
        }

        setItems(updatedItems);
        setUDI(prev => ({
            ...prev,
            ClinicalSizes: updatedItems
        }));
        popup.close();
    };

    const handleRemove = (index) => {
        const updatedItems = items.filter((_, i) => i !== index);
        setItems(updatedItems);
        setUDI(prev => ({
            ...prev,
            ClinicalSizes: updatedItems
        }));
        resetForm();
    };

    const handleEdit = (index) => {
        setFormData(items[index]);
        setEditingIndex(index);
        popup.openEdit();
    };

    const resetForm = () => {
        setFormData(initialFormState);
        setEditingIndex(null);
    };

    const popup = useUDIRowPopup(resetForm);

    const formatDescription = (descObj) => {
        if (!descObj?.Value) return "";
        return `${descObj.Language?.Text}: ${descObj.Value}`;
    };

    // --- Render Table ---
    const TableMarkup = () => (
        <table className={"table table-bordered"} style={{ width: '100%', borderWidth: '1px' }}>
            <thead>
                <tr>
                    <th>Type</th>
                    <th>Precizion</th>
                    <th>Measure Unit</th>
                    <th>Maximum</th>
                    <th>Minimum</th>
                    <th>Value</th>
                    <th>Value Text</th>
                    <th>Type Description</th>
                    <th>Unit Description</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {items.map((item, index) => (
                    <tr key={index} className={editingIndex === index ? 'udi-complex-field-row-selected' : ''}>
                        <td>{item.SizeType?.Text}</td>
                        <td>{item.Precizion?.Text}</td>
                        <td>{item.MeasureUnit?.Text}</td>
                        <td>{item.Maximum}</td>
                        <td>{item.Minimum}</td>
                        <td>{item.Value}</td>
                        <td>{item.ValueText}</td>
                        <td style={{ whiteSpace: 'pre-wrap' }}>{formatDescription(item.TypeDescription)}</td>
                        <td style={{ whiteSpace: 'pre-wrap' }}>{formatDescription(item.UnitDescription)}</td>
                        <td>
                            <button type="button" className="udiEditButton" onClick={() => handleEdit(index)}>
                                <i className="fas fa-edit"></i>
                            </button>
                            <button type="button" className="udiRemoveButton" onClick={() => handleRemove(index)}>
                                <i className="fas fa-times-circle"></i>
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );



    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditing(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditing(forceIsEditing);

    }, [forceIsEditing]);



    return (



        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>

                        {isEditing ?

                            <>
                                <TableMarkup />

                                <UDIAddRowButton label="Add Clinical Size" onClick={popup.openAdd} />

                                <UDIRowPopup
                                    isOpen={popup.isOpen}
                                    title={editingIndex !== null ? "Edit Clinical Size" : "Add Clinical Size"}
                                    saveLabel={editingIndex !== null ? "Save" : "Add"}
                                    onClose={popup.close}
                                    onSave={handleSave}
                                >
                                    <UDIPopupField label="Size Type">
                                        <select value={formData.SizeType.Value} onChange={(e) => handleDropdownChange(e, 'SizeType', sizeTypes)}>
                                            {sizeTypes.map(s => <option key={s.key} value={s.key}>{s.value}</option>)}
                                        </select>
                                    </UDIPopupField>
                                    <UDIPopupField label="Precizion">
                                        <select value={formData.Precizion.Value} onChange={(e) => handleDropdownChange(e, 'Precizion', precision)}>
                                            {precision.map(p => <option key={p.key} value={p.key}>{p.value}</option>)}
                                        </select>
                                    </UDIPopupField>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '12px' }}>
                                        <UDIPopupField label="Maximum">
                                            <input type="text" name="Maximum" value={formData.Maximum} onChange={handleInputChange} />
                                        </UDIPopupField>
                                        <UDIPopupField label="Minimum">
                                            <input type="text" name="Minimum" value={formData.Minimum} onChange={handleInputChange} />
                                        </UDIPopupField>
                                        <UDIPopupField label="Value">
                                            <input type="text" name="Value" value={formData.Value} onChange={handleInputChange} />
                                        </UDIPopupField>
                                        <UDIPopupField label="Value (Text)">
                                            <input type="text" name="ValueText" value={formData.ValueText} onChange={handleInputChange} />
                                        </UDIPopupField>
                                    </div>
                                    <UDIPopupField label="Measure Unit">
                                        <select value={formData.MeasureUnit.Value} onChange={(e) => handleDropdownChange(e, 'MeasureUnit', measureUnits)}>
                                            {measureUnits.map(m => <option key={m.key} value={m.key}>{m.value}</option>)}
                                        </select>
                                    </UDIPopupField>
                                    <UDIPopupField label="Clinical Size Type Description">
                                        <select value={formData.TypeDescription.Language.Value} onChange={(e) => handleNestedLanguageChange(e, 'TypeDescription')} style={{ marginBottom: '5px' }}>
                                            {languages.map(l => <option key={l.key} value={l.key}>{l.value}</option>)}
                                        </select>
                                        <textarea value={formData.TypeDescription.Value} onChange={(e) => handleNestedValueChange(e, 'TypeDescription')} rows={2} />
                                    </UDIPopupField>
                                    <UDIPopupField label="Measure Unit Description">
                                        <select value={formData.UnitDescription.Language.Value} onChange={(e) => handleNestedLanguageChange(e, 'UnitDescription')} style={{ marginBottom: '5px' }}>
                                            {languages.map(l => <option key={l.key} value={l.key}>{l.value}</option>)}
                                        </select>
                                        <textarea value={formData.UnitDescription.Value} onChange={(e) => handleNestedValueChange(e, 'UnitDescription')} rows={2} />
                                    </UDIPopupField>
                                </UDIRowPopup>

                                <input type="hidden" name={hiddenFieldName} value={JSON.stringify(items)} />
                            </>

                            :


                            <>

                                <table className={"dataTable"} style={{ width: '100%', borderWidth: '1px' }}>
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Precizion</th>
                                            <th>Measure Unit</th>
                                            <th>Maximum</th>
                                            <th>Minimum</th>
                                            <th>Value</th>
                                            <th>Value Text</th>
                                            <th>Type Description</th>
                                            <th>Unit Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr key={index} >
                                                <td>{item.SizeType?.Text}</td>
                                                <td>{item.Precizion?.Text}</td>
                                                <td>{item.MeasureUnit?.Text}</td>
                                                <td>{item.Maximum}</td>
                                                <td>{item.Minimum}</td>
                                                <td>{item.Value}</td>
                                                <td>{item.ValueText}</td>
                                                <td style={{ whiteSpace: 'pre-wrap' }}>{formatDescription(item.TypeDescription)}</td>
                                                <td style={{ whiteSpace: 'pre-wrap' }}>{formatDescription(item.UnitDescription)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/*
						        <input
							        type="button"
							        className="udiActionButton"
							        value="Edit"
							        onClick={() => changeIsEditingField(true)}
						        />
                                */}


                            </>

                        }

                    </div>

                </div>
            </div>
        </div>



    );
};

export default ClinicalSizes;